<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>

        <async-selector
                api-url="/api/backend/composer/resources/products/"
                :selected="currentIds"
                :multiple="true"
                @updated="selectorUpdated"
        ></async-selector>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    import AsyncSelector from "../../UI/components/AsyncSelector";

    export default {
        components: {
            AsyncSelector,
        },
        mixins: [
            fieldInfo,
        ],
        data: function () {
            return {
                currentIds: [],
            }
        },
        methods: {
            selectorUpdated(newValue) {
                this.currentIds = newValue;
            }
        },
        watch: {
            currentIds(newValue) {
                if (newValue == null) {
                    newValue = [];
                }
                this.currentValue = newValue.join(',');
            }
        },
        created() {
            let stringWithIds = this.currentValue;
            this.currentIds = stringWithIds.split(',').filter(function (value) {
                return !!value;
            }).map(function (value) {
                return parseInt(value);
            });
        }
    }
</script>

<style scoped>

</style>
